(() => {
  function init(root) {
    root.querySelectorAll('.lise-editorial').forEach(editorial => {
      if (editorial.dataset.controlsReady) return;
      editorial.dataset.controlsReady = 'true';
      const modal = editorial.querySelector('#consult-modal');
      if (!modal) return;
      const close = modal.querySelector('.close');
      if (!close) return;
      let trigger, previousOverflow;
      function hide() {
        modal.classList.remove('open');
        document.body.style.overflow = previousOverflow || '';
        trigger?.focus();
      }
      editorial.querySelectorAll('[data-consult]').forEach(button => button.addEventListener('click', () => {
        trigger = button;
        previousOverflow = document.body.style.overflow;
        modal.classList.add('open'); document.body.style.overflow = 'hidden';
        const frame = modal.querySelector('iframe[data-src]');
        if (frame) { frame.src = frame.dataset.src; frame.removeAttribute('data-src'); }
        close.focus();
      }));
      close.addEventListener('click', hide);
      modal.addEventListener('click', event => { if (event.target === modal) hide(); });
      modal.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); hide(); }
        if (event.key !== 'Tab') return;
        const items = [...modal.querySelectorAll('button,a[href],iframe,input,select,textarea,[tabindex="0"]')].filter(el => !el.disabled && el.getClientRects().length);
        const first = items[0], last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
